<template>
  <main>
    <HomeHero />
    <HomeServices />
    <HomeAdvantage />
    <HomeCases />
    <HomeFlow />
    <HomeCTA />
  </main>
</template>

<script setup>
import HomeHero from '@/components/home/HomeHero.vue'
import HomeServices from '@/components/home/HomeServices.vue'
import HomeAdvantage from '@/components/home/HomeAdvantage.vue'
import HomeCases from '@/components/home/HomeCases.vue'
import HomeFlow from '@/components/home/HomeFlow.vue'
import HomeCTA from '@/components/home/HomeCTA.vue'
</script>
